"use strict";
/**
 * TransactionHistoryTable component contract
 *
 * Shared between super-admin-ui and platform-app. Super-admin uses
 * `context: 'admin'`, tenant-facing (platform-app, Wave 2) uses
 * `context: 'self'`. Both apps must implement a component with this
 * exact prop interface so behavior stays consistent.
 *
 * NOTE: this file intentionally contains TypeScript interfaces only — no
 * runtime Zod schema. The table's *data* flows via
 * APosAgentAdminTenantHistoryResponseSchema (see agent-admin.schema.ts).
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=transaction-history-props.js.map